import { ArrowLeft } from 'lucide-react';
import PropTypes from 'prop-types';
import { useParams } from "react-router-dom";
import EmployeesTable from "../EmployeesTable/EmployeesTable";
import ManagersTable from "../ManagersTable/ManagersTable";
import "./TableContainer.scss";

const TableContainer = ({ data, setPage, hideTable, isLoading }) => {
  const { type } = useParams();
  const safeData = data || { items: [], page: 1, totalPages: 1, totalItems: 0 };

  return (
    <div className={`TableContainer ${hideTable ? "inactive" : ""}`}>
      {isLoading ? (
        <div className="table-loading-state" aria-live="polite">
          <div className="table-loading-spinner">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2">
                <path
                  strokeDasharray="60"
                  strokeDashoffset="60"
                  strokeOpacity="0.3"
                  d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"
                >
                  <animate fill="freeze" attributeName="stroke-dashoffset" dur="1.3s" values="60;0" />
                </path>
                <path
                  strokeDasharray="15"
                  strokeDashoffset="15"
                  d="M12 3C16.9706 3 21 7.02944 21 12"
                >
                  <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.3s" values="15;0" />
                  <animateTransform
                    attributeName="transform"
                    dur="1.5s"
                    repeatCount="indefinite"
                    type="rotate"
                    values="0 12 12;360 12 12"
                  />
                </path>
              </g>
            </svg>
          </div>
          <p>Carregando {type === "gestores" ? "gestores" : "colaboradores"}...</p>
        </div>
      ) : (
        type === "gestores" ? <ManagersTable data={safeData} /> : <EmployeesTable data={safeData} />
      )}
      <div className="table-footer">
        {!isLoading && safeData.totalPages > 1 && (
          <div className="pagination">
            <div className="pagination-info">
              <div className="page-indicator">
                <span>Página</span>
                <span className="page-number">{safeData.page}</span>
                <span className="total-pages">de {safeData.totalPages}</span>
              </div>
              <div className="items-count">
                <span className="items-number">{safeData.totalItems}</span>
                <span>no total</span>
              </div>
            </div>
            <div className="pagination-controls">
              <button
                onClick={() => setPage(safeData.page - 1)}
                disabled={safeData.page === 1}
                className="pagination-btn"
              >
                <ArrowLeft className="btn-icon" />
                <span>Anterior</span>
              </button>

              <div className="page-separator"></div>

              <div className="current-page-display">
                {safeData.page}
              </div>

              <div className="page-separator"></div>

              <button
                onClick={() => setPage(safeData.page + 1)}
                disabled={safeData.page === safeData.totalPages}
                className="pagination-btn"
              >
                <span>Próxima</span>
                <ArrowLeft className="btn-icon" style={{ transform: 'rotate(180deg)' }} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

TableContainer.propTypes = {
  data: PropTypes.object,
  hideTable: PropTypes.bool,
  isLoading: PropTypes.bool,
  setPage: PropTypes.func.isRequired
};

export default TableContainer;
